import {combineReducers} from 'redux';
import userConnectsReducer from "./userconnects/UserConnectionsReducer";
import userInfoReducer from './userinfo/UserInfoReducer';
import apiKeyReducer from './apikey/ApiKeyReducer';


export default function rootReducer() {
  return combineReducers({
    userConnects: userConnectsReducer,
    user: userInfoReducer,
    apiKeyReducer: apiKeyReducer
  });
}
